import { DeliveryTypeCategory } from '@/features/orders/constants/app'
import DeliveryTypeCategorySelector from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/DeliveryTypeCategorySelector'
import PhoneModeFields from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields'
import { usePosMode } from '@/features/pos/contexts/PosMode'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface FormFieldsProps {
    deliveryTypeCategories: DeliveryTypeCategory[]
}

const FormFields: FC<FormFieldsProps> = ({ deliveryTypeCategories }) => {
    const mode = usePosMode()

    if (mode === 'pos') {
        return (
            <DeliveryTypeCategorySelector
                deliveryTypeCategories={deliveryTypeCategories}
                containerStyle={{ width: '100%', maxWidth: 320 }}
            />
        )
    }

    return (
        <View style={styles.container}>
            <DeliveryTypeCategorySelector
                deliveryTypeCategories={deliveryTypeCategories}
                containerStyle={styles.deliveryTypeSwitcher}
            />
            <PhoneModeFields deliveryTypeCategories={deliveryTypeCategories} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        alignSelf: 'stretch',
        flexDirection: 'row',
        flexWrap: 'wrap',
        rowGap: 16,
        width: '100%',
    },
    deliveryTypeSwitcher: {
        flexBasis: '100%',
        width: '100%',
    },
})

export default FormFields
